import { forEach } from 'lodash';
import { MapQueryParams, SortingParams } from '../types/Plagiarism';

function mapQueryToParams(query?: MapQueryParams, sorting?: SortingParams): URLSearchParams {
  const params = new URLSearchParams();
  const itemsToMap = { ...query, ...sorting };

  forEach(itemsToMap, (value, key) => {
    if (value) params.append(key, value.toString());
  });
  return params;
}

export { mapQueryToParams };
